import { toInteger } from "lodash";
import { eramanCMSApi } from "~/Services";
import { decodeHTML } from "~/Utils/CommonUtils";
import { ModuleFields } from "~/Utils/drilldownData";

// Define the option type for select fields
export interface OptionType {
  label: string;
  value: string;
}

// Create a type for fields that may have async options
export type AsyncSelectField = ModuleFields & {
  loadOptions?: () => Promise<OptionType[]>;
};

// Function to fetch data and transform to options
export const fetchDataAndTransform = async (
  url: string,
  labelKey: string,
  valueKey?: string,
  filterFn?: (item: any) => boolean
): Promise<OptionType[]> => {
  try {
    const res = await eramanCMSApi.get(`${url}`);
    if (res?.data) {
      const filteredData = filterFn ? res.data.filter(filterFn) : res.data;
      return filteredData.map((item: any) => ({
        label: decodeHTML(item[labelKey]),
        value: valueKey ? decodeHTML(item[valueKey]) : decodeHTML(item[labelKey]),
      }));
    }
    return [];
  } catch (err) {
    console.error("Error fetching data:", err);
    return [];
  }
};

export const fetchSubCategoriesData = () => fetchDataAndTransform("/api/get-all-sub-categories", "name", "name");

export const fetchCategoriesData = () =>
  fetchDataAndTransform("/api/get-categories", "field_category_name", "field_category_name", (item) =>
    [73, 74, 75].includes(item.tid)
  );
export const fetchCategoriesDataById = () =>
  fetchDataAndTransform("/api/get-categories", "field_category_name", "tid", (item) => [73, 74, 75].includes(item.tid));

export const fetchCategoriesBannerData = () =>
  fetchDataAndTransform("/api/get-categories", "field_category_name", "field_category_name", (item) =>
    [73, 74, 75, 289].includes(item.tid)
  );

export const fetchBrandsData = () => fetchDataAndTransform("/api/get-brand-dropdown", "title", "title");

export const fetchAirportDropdownData = () => fetchDataAndTransform("/api/airport-dropdown", "name", "name");
export const fetchFoodBevarageDropdowData = () => fetchDataAndTransform("/api/food-beverage-dropdown", "name", "name");

export const fetchStoreDropdownData = async () => {
  try {
    const res = await eramanCMSApi.get(`/api/store-location-dropdown`);
    console.log("loadOptionsdata", res.data);
    if (res?.data?.data) {
      return res.data.data.map((item: any) => ({
        label: decodeHTML(item.name),
        value: toInteger(item.id),
      }));
    }
    return [];
  } catch (err) {
    console.error("Error fetching data:", err);
    return [];
  }
};

export const fetchStoreDropdownDataByName = async () => {
  try {
    const res = await eramanCMSApi.get(`/api/store-location-dropdown`);
    if (res?.data?.data) {
      return res.data.data.map((item: any) => ({
        label: decodeHTML(item.name),
        value: item.name,
      }));
    }
    return [];
  } catch (err) {
    console.error("Error fetching data:", err);
    return [];
  }
};

export const fetchStoreDropdownDataByStringId = async () => {
  try {
    const res = await eramanCMSApi.get(`/api/store-location-dropdown`);
    if (res?.data?.data) {
      return res.data.data.map((item: any) => ({
        label: decodeHTML(item.name),
        value: item.id,
      }));
    }
    return [];
  } catch (err) {
    console.error("Error fetching data:", err);
    return [];
  }
};
